import React from 'react';
import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import HeaderContainer from '@ui/features/Header/Header.container';
import SubusersContainer from '@ui/features/Subusers/Subusers.container';
import MainContainer from '@ui/features/Main/Main.container';
import withPage from '@ui/HOCs/withPage';
import withSideBar from '@ui/HOCs/withSideBar';
import withSection from '@ui/HOCs/withSection';
import withSections from '@ui/HOCs/withSections';
import { lang } from '@lang/interfaces/lang';

interface IProps extends JSX.IntrinsicAttributes {
    lang: lang;
}

const SideBar = withSideBar(SubusersContainer);
const Section = withSection(MainContainer);
const Sections = withSections(Section);

const Page: React.FC<IProps> = () => {
    return (
        <>
            <HeaderContainer />
            <Box className="main" component="main">
                <SideBar />
                <Sections />
            </Box>
        </>
    );
};

const WrappedPage = withPage(Page, 'main__wrap', 'subusers');

const MainPage = observer(WrappedPage);

export default MainPage;
